<template>
  <div class="page">
    <fixed-header :title="title" :black="true" :left="true" />
    <div v-if="loading" class="center">
      <van-loading size="36px"></van-loading>
    </div>
    <div
      v-else-if="pageData"
      class="detail-wrap"
      v-html="pageData.agreementContent"
    ></div>
    <div v-else class="center">
      <img src="../../../assets/imgs/no-data.png" width="40%" alt="" />
      <p>暂无内容</p>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import { Toast } from "vant";
import { queryAgreementDetail } from "../../../api";
import FixedHeader from "../../../components/FixedHeader";
import { callAppHandler } from "../../../utils";

Vue.use(Toast);

export default {
  name: "agreement",
  components: {
    FixedHeader,
  },
  data() {
    return {
      pageData: null,
      loading: false,
      title: "协议内容",
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapState(["isApp"]),
  },
  methods: {
    getData() {
      let { agreementId, businessCode } = this.$route.query;

      if (!agreementId) {
        Toast("协议ID丢失");
        return;
      }

      if (!businessCode) {
        Toast("协议code丢失");
        return;
      }

      const params = { agreementId, businessCode };
      this.loading = true;
      return queryAgreementDetail(params)
        .then((res) => {
          if (res.code === 200) {
            this.pageData = res.data;
            this.handleTitle(res.data);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleTitle(data) {
      this.setTitle(data.agreementName || "协议内容");
    },

    setTitle(title) {
      this.title = title;
      document.title = title;
      if (this.isApp) {
        callAppHandler({
          type: "setTitle",
          params: { title },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/style/variable.less";
.page {
  height: 100vh;
  background: #fff;
  overflow-y: auto;
  .detail-wrap {
    word-wrap: break-word;
    font-size: 14px;
    padding: 15px;
  }
  .center {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 14px;
    color: #999999;
  }
}
</style>
